import { Component, Input, OnDestroy, OnInit, } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import {
  ExpandResourceFacetsBlockAction,
  LazyFacetLoadAction,
  loadSingleLazyFacet,
  ResourceFacetBlockSelectedAction,
} from 'search/actions/facet.actions';
import { FacetState } from 'search/facets/models/facet-state';
import { ResourceFacetBlock } from 'search/models/filter-panel';
import { DEFAULT_LAZY_LOADED_FACET_SEARCH_OBJECT, MappedSearchObject } from 'search/models/search-object';
import { getSearchObject, getV2Facets, State, } from 'search/reducers/root.reducer';
import { FeatureToggleService } from '../../../services/feature-toggle.service';

@Component({
  selector: 'app-facet-expansion-panel',
  templateUrl: './facet-expansion-panel.component.html',
  styleUrls: ['./facet-expansion-panel.component.scss'],
})
export class FacetExpansionPanelComponent implements OnInit, OnDestroy {

  public readonly resourceFacetBlock = ResourceFacetBlock;
  @Input() public facetKey: string;
  @Input() public blockName: string;
  @Input() public count: number;
  @Input() public expanded: boolean;
  @Input() public id: string;
  public subscriptions = new Subscription();
  public loadedFacets: FacetState[];
  public searchObject: MappedSearchObject;

  constructor(
    private readonly store: Store<State>,
    private readonly featureToggleService: FeatureToggleService
  ) {
  }

  public ngOnInit() {
    this.subscriptions.add(this.store.pipe(select(getV2Facets)).subscribe((facets: FacetState[]) => {
      this.loadedFacets = facets;
    }));
    this.subscriptions.add(this.store.pipe(select(getSearchObject)).subscribe((searchObject) => {
      this.searchObject = searchObject;
    }));
  }

  public onBlockChecked() {
    this.store.dispatch(new ResourceFacetBlockSelectedAction({facetKey : this.facetKey}));
  }

  public toggleOpenState(opened: boolean): void {
    if (this.shouldLoadLazyFacet(opened)) {
      this.loadLazyFacet();
    }

    if (this.shouldExpandFacets(opened)) {
      this.expandFacets(opened);
    }
  }

  private shouldLoadLazyFacet(opened: boolean): boolean {
    const existedFacets = this.getExistedFacets();

    if (opened && existedFacets && !existedFacets.schemaWithData.data.data.length) {
      if (['agent', 'concept'].includes(this.id)) {
        return true;
      }
      if (['location'].includes(this.id)) {
        return true;
      }
      if (this.featureToggleService.getToggles()['VE-4775_2024-07-31_format_facet_search'] && ['materialType'].includes(this.id)) {
        return true;
      }
    }
    return false;
  }

  private loadLazyFacet(): void {
    const facetType = this.id;
    const searchObject = {
      ...this.searchObject,
      ...(DEFAULT_LAZY_LOADED_FACET_SEARCH_OBJECT[this.id] || {}),
    };

    if (['agent', 'concept'].includes(this.id)) {
    return this.store.dispatch(new LazyFacetLoadAction({
        searchObject: {
          ...this.searchObject,
          facetTypes: [this.id],
        },
        changedQuery: false,
      }));
    }

   return this.store.dispatch(loadSingleLazyFacet({
      facetType,
      searchObject,
      changedQuery: false,
    }));
  }

  private shouldExpandFacets(opened: boolean): boolean {
    return opened !== this.expanded;
  }

  private expandFacets(opened: boolean): void {
    this.store.dispatch(new ExpandResourceFacetsBlockAction({
      facetKey: this.facetKey,
      expanded: opened,
    }));
  }

  private getExistedFacets(): any {
    return this.loadedFacets.find((facet) => facet.schemaWithData.schema.mapField === this.id) as any;
  }

  public ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
